// extracted by mini-css-extract-plugin
export default {"middlePage":"middlePage_middlePage__lZlmg","rightContainer":"middlePage_rightContainer__zcVX5"};